import React, { useState, useEffect } from "react";
import "./Login.css";
import { useStateValue } from "./StateProvider";
import { Link, useHistory } from "react-router-dom";
import { auth } from "./firebase";
// import { db } from "./firebase";

function Login() {
  const history = useHistory();
  const [eventDate, dispatch] = useStateValue();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [{ user }] = useStateValue();

  useEffect(() => {
    const d = new Date();
    const y = d.getFullYear();
    const mm = (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1);
    const dd = (d.getDate() < 10 ? "0" : "") + d.getDate();
    const eventDateNow = y + "" + mm + "" + dd;
    localStorage.setItem("eventDate", JSON.stringify(eventDateNow));
    // console.log("Date Fxn",eventDateNow)
    dispatch({
      type: "EVENTDATE",
      eventDate: eventDateNow,
    });
  }, []);

  const login = (event) => {
    event.preventDefault(); //stops the refresh
    //login logic
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        // console.log(auth)
        //logged in and redirect to homepage
        history.push("/setup")
        // :alert("Email verification Required") 
      })
      .catch((e) => alert(e.message));
  };

  const SendPasswordReset = () => {
   
    var emailAddress = email;
    auth
      .sendPasswordResetEmail(emailAddress)
      .then(function () {
        // Email sent.
        alert("Password reset email sent to " + email)
      })
      .catch(function (error) {
        // An error happened.
        alert(error)
      });
  };

  return (
    <div className="login">
      <Link to="/">
        <img
          className="login__logo"
          src="/logo512.png"
          alt=""
        />
      </Link>

      <div className="login__container">
        <span className="title">Huron Pines Events</span>
        <h1>Sign in</h1>

        <form>
          <h5>E-mail</h5>
          <input
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            autoComplete="email"
          />
          <div className="password">
          <span>Password</span>
          <a href="#" onClick={()=>SendPasswordReset()}  className="reset__password">Forgot Password</a>
          </div>
          <input
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            autoComplete="password"
          />
          <button onClick={login} type="submit" className="login__signInButton">
            Sign in
          </button>
          
        </form>
        <p>
          By signing in you agree to testing a beta scoring program. Do not give
          the programmer any grief as bugs can and do occur.
        </p>
      </div>
      <span className="new">New to Huron Pines?</span>
      <button
        onClick={(e) => history.push("/register")}
        className="login__RegisterButton"
      >
        Create your Huron Pines Account
      </button>
    </div>
  );
}

export default Login;
